import apiClient from 'apiClientRef';
import localCart from "./localCart.js";

var currentShop = apiClient.currentShopInfo;
var onLoginApi = null;

var _listenerRef = {
    onPromptLogin: null,
    onLogoutListener: null
};

function addToCartCombo(data) {
    return new Promise(function (rs, rj) {
        apiClient.shoppingCart.apiClient.pingPrms().then(function (ret) {
            console.log('ret of ping:', ret);
            if (ret.hasLogin === true) {
                apiClient.addToCartPrms(data).then(function (ret) {
                    rs(ret);
                });
            } else {
                localCart.api.addToCartPrms(data).then(function (ret) {
                    rs(ret);
                });
            }
        });
    });
}

var cartApiClient = {
    pingPrms: function () {
        var prm = new Promise(function (rs, rj) {
            apiClient.shoppingCart.apiClient.pingPrms().then(function (ret) {
                if (ret.hasLogin !== true) {
                    _listenerRef.store.commit("setAccount", null);
                }
                rs(ret);
            });   
        });
        return prm;
    },
    addToCartPrms: addToCartCombo,
    //addToCartPrms: apiClient.addToCartPrms,
    getLocalCartItemsPrms: apiClient.shoppingCart.apiClient.getLocalCartItemsPrms,
    getCartItemsPrms: apiClient.shoppingCart.apiClient.getCartItemsPrms,
    registerItem: apiClient.shoppingCart.registerItem,
    checkout: apiClient.shoppingCart.checkout,
    setOnRemove: apiClient.shoppingCart.setOnRemove,
    getPoliciesPrms: apiClient.getPoliciesPrms,
    onLoginApi: onLoginApi
}

var detailApiClient = {
    addToCartPrms: addToCartCombo,
    //addToCartPrms: apiClient.addToCartPrms,
    getPricesPrms: apiClient.getPricesPrms,
    getPostCatLabelsPrms: apiClient.getPostCatLabelsPrms,
    getPostTagsPrms: apiClient.getPostTagsPrms,
    getPostByIdPrms: apiClient.getPostByIdPrms,
    getQAPrms: apiClient.getQAPrms,
    addQAPrms: apiClient.addQAPrms,
    onLoginApi: onLoginApi
}

var qaApiClient = {
    getQAPrms: apiClient.getQAPrms,
    addQAPrms: apiClient.addQAPrms,
    onLoginApi: onLoginApi
};

var accountApiClient = {
    getProfilePrms: apiClient.getProfilePrms,
    deleteAccountPrms: apiClient.deleteAccountPrms,
    logoutPrms: function () {
        if (_listenerRef.onLogoutListener !== null) {
            _listenerRef.onLogoutListener();
        } else {
            apiClient.logoutPrms().done(function () {
                _listenerRef.onLogout();
            });
        }
    },
    qaApiClient: qaApiClient,
    onLoginApi: onLoginApi
};

var listingApiClient = {
    getItemsPrms: apiClient.getShopItemsPrms
};

var pagedInfosApiClient = {
    getItemsPrms: apiClient.getPagedInfosPrms
};

var orderDetailApiClient = {
    getOrderDetailPrms: apiClient.getOrderDetailPrms,
    loadPaypalPrms: apiClient.loadPaypalPrms,
    createPaypalPaymentPrms: apiClient.createPaypalPaymentPrms,
    executePaypalPaymentPrms: apiClient.executePaypalPaymentPrms,
    orderStateCodes: apiClient.orderStateCodes,
    setManualPaymentPrms: apiClient.setManualPaymentPrms
}

var forgotLoginApiClient = {
    forgotLoginPrms: apiClient.forgotLoginPrms,
    getProfilePrms: apiClient.getProfilePrms
}

var registerApiClient = {
    registerPrms: apiClient.registerPrms,
    getProfilePrms: apiClient.getProfilePrms
}

var ordersApiClient = {
    getOrderListPrms: apiClient.getOrderListPrms
}

var articlesApiClient = {
    getItemsPrms: apiClient.getArticlesPrms
}

var articleDetailApiClient = {
    getArticleByIdPrms: apiClient.getArticleByIdPrms
}

var policiesApiClient = {
    getItemsPrms: apiClient.getPoliciesPrms
}

var contactsApiClient = {
    addContactPrms: apiClient.addContactPrms,
    getContactsPrms: apiClient.getContactsPrms,
    getPickupContactsPrms: apiClient.getPickupContactsPrms,
    getPickupContactByIdPrms: apiClient.getPickupContactByIdPrms,
    //phoneAreaSelector: apiClient.shoppingCart.phoneAreaSelector,
    //citySelector: apiClient.shoppingCart.citySelector,
    //pickupSelector: apiClient.shoppingCart.pickupSelector,
    pickupEnabled: currentShop.shop.pickupEnabled,
    getCityPrms: function(){
        return apiClient.getCategoryNodePrms(4,null);
    },
    getPhoneDistrictPrms:function(){
        return apiClient.getCategoryNodePrms(5,null);
    },
    getPickupPrms:function(shopUserId){
        return apiClient.getCategoryNodePrms(8,shopUserId);
    }
}

function getCompositeApiClient(opts) {
    onLoginApi = opts.onLoginApi;
    _listenerRef = opts.listenerRef;

    cartApiClient.onLoginApi = onLoginApi;
    detailApiClient.onLoginApi = onLoginApi;
    qaApiClient.onLoginApi = onLoginApi;
    accountApiClient.onLoginApi = onLoginApi;
    ordersApiClient.onLoginApi = onLoginApi;
    orderDetailApiClient.onLoginApi = onLoginApi;

    return {
        apiClient: apiClient,
        cartApiClient: cartApiClient,
        detailApiClient: detailApiClient,
        qaApiClient: qaApiClient,
        accountApiClient: accountApiClient,
        listingApiClient: listingApiClient,
        pagedInfosApiClient: pagedInfosApiClient,
        orderDetailApiClient: orderDetailApiClient,
        forgotLoginApiClient: forgotLoginApiClient,
        registerApiClient: registerApiClient,
        ordersApiClient: ordersApiClient,
        articlesApiClient: articlesApiClient,
        articleDetailApiClient: articleDetailApiClient,
        policiesApiClient: policiesApiClient,
        contactsApiClient: contactsApiClient
    }
}


export default {
    api: {
        currentShop: currentShop,
        getCompoApiClient: getCompositeApiClient
    }
}